import React, { memo } from 'react';
import { useVFXConfig } from '@/features/vfx/hooks/useVFXConfig';
import BackgroundLayer from '@/features/vfx/components/BackgroundLayer';
import VFXCanvas from '@/features/vfx/components/VFXCanvas';
import NotificationContainer from '@/components/NotificationContainer';
import AutoLogoutWarning from '@/components/AutoLogoutWarning';
import { useAutoRedirect } from '@/hooks/useAutoRedirect';
import { useKioskHeartbeat } from '@/hooks/useKioskHeartbeat';
import { usePageAnimationsEnabled } from '@/contexts/AnimationContext';
import KioskOfflineOverlay from '@/components/KioskOfflineOverlay';

interface BaseLayoutProps {
  children: React.ReactNode;
}

// Stable sub-components so VFX/background updates don't re-render page content
const GlobalOverlays = memo(() => (
  <>
    <NotificationContainer />
    <AutoLogoutWarning />
    <KioskOfflineOverlay />
  </>
));
GlobalOverlays.displayName = 'GlobalOverlays';

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { vfxConfig, backgroundConfig } = useVFXConfig();
  /** Tắt particle canvas khi user tắt animation (CSS rule lo phần còn lại) */
  const pageAnimationsEnabled = usePageAnimationsEnabled();

  useAutoRedirect();
  useKioskHeartbeat();

  return (
    <div className="relative flex flex-col h-dvh min-h-0 overflow-hidden">
      <BackgroundLayer config={backgroundConfig} />
      {pageAnimationsEnabled && <VFXCanvas config={vfxConfig} />}
      <div className="relative z-[1] flex flex-1 min-h-0 flex-col overflow-hidden">
        {children}
      </div>
      <GlobalOverlays />
    </div>
  );
};

export default memo(BaseLayout);
